class AnimationDataProvider {
  constructor() {
    this.isTablet = window.matchMedia("(max-width: 1024px)").matches;
    this.isMobile = window.matchMedia("(max-width: 650px)").matches;

    this.currentState = {
      DESTINATION_NAVBAR: null,
      CHECK_AVAILABILITY_BTN_ELEMENT: null,
      TIMELINE: null,
      SCROLLTO_ACTIVE: false,
    };

    this.proxyCurrentState = new Proxy(this.currentState, this.handler());

    this.elements = {
      NAVBAR_ELEMENT: document.querySelector(".js-navbar-sticky-wrapper"),
      TOPBAR_ELEMENT: document.querySelector(".js-top-navbar-sticky-wrapper"),
      BOOKING_ELEMENT: document.querySelector(".js-booking-bar-animation-wrapper"),
      BOOKING_MOBILE_ELEMENT: document.querySelector(".js-booking-bar-mobile-btn"),
      HEADER_ELEMENT: document.querySelector(".js-header-wrapper"),
      DROPDOWN_TOGGLE_ELEMENTS: document.querySelectorAll(".js-booking-bar-animation-wrapper .dropdown-toggle"),
      SUBMIT_BUTTON: document.querySelectorAll(".js-booking-bar-animation-wrapper .js-booking-bar-submit"),
      DESTINATION_NAME_ELEMENT: document.querySelector(".js-header-destination-name-wrapper-sticky"),
      DESTINATION_NAVBAR_ELEMENT: document.querySelector(".js-destination-navbar"),
      CHECK_AVAILABILITY_BTN_ELEMENT: document.querySelector(".js-nastanitev-sticky-button-wrapper"),
      CHECK_AVAILABILITY_BTN_TRIGGER: document.querySelector(".js-nastanitev-button-trigger"),
    };

    this.hasBookingBar = this.elements.BOOKING_ELEMENT !== null;
    this.hasDestinationMenu = this.elements.DESTINATION_NAME_ELEMENT !== null;

    this.elementProps = {
      NAVBAR_ELEMENT_HEIGHT: document.querySelector(".js-navbar-sticky-wrapper").getBoundingClientRect().height,
      TOPBAR_ELEMENT_HEIGHT: document.querySelector(".js-top-navbar-sticky-wrapper").getBoundingClientRect().height,
      BOOKING_ELEMENT_HEIGHT: this.setBookingElementHeight(),
      DESTINATION_NAME_ELEMENT_HEIGHT: this.elements.DESTINATION_NAME_ELEMENT
        ? this.elements.DESTINATION_NAME_ELEMENT.getBoundingClientRect().height
        : 0,
      DESTINATION_NAVBAR_ELEMENT_HEIGHT: this.elements.DESTINATION_NAVBAR_ELEMENT
        ? this.elements.DESTINATION_NAVBAR_ELEMENT.getBoundingClientRect().height
        : 0,
      CHECK_AVAILABILITY_BTN_ELEMENT_HEIGHT: this.elements.CHECK_AVAILABILITY_BTN_ELEMENT
        ? this.elements.CHECK_AVAILABILITY_BTN_ELEMENT.getBoundingClientRect().height
        : 0,
    };

    this.constants = {
      STICKY_THRESHOLD: 60,
      BOOKING_INITIAL: this.setBookingInitial(),
      BOOKING_STICKY_INIT: 0,
      BOOKING_STICKY_UP: this.elementProps.NAVBAR_ELEMENT_HEIGHT,
      BOOKING_STICKY_DOWN: this.setBookingStickyDown(),
      NAVBAR_STICKY_INIT: this.elementProps.TOPBAR_ELEMENT_HEIGHT,
      NAVBAR_STICKY_UP: 0,
      NAVBAR_STICKY_DOWN: -100,
      LOGO_STICKY_HEIGHT: 50,
    };
  }

  // Init singleton
  static getInstance() {
    if (!this.instance) {
      this.instance = new AnimationDataProvider();
    }
  }

  handler() {
    return {
      set: (target, prop, value) => {
        if (prop in target) {
          // eslint-disable-next-line no-param-reassign
          target[prop] = value;

          const eData = {};
          eData[prop] = value;

          document.dispatchEvent(
            new CustomEvent("stateChange", {
              detail: {
                state: eData,
              },
            }),
          );

          if (prop === "DESTINATION_NAVBAR") {
            this.constants.BOOKING_STICKY_DOWN = this.setBookingStickyDown();
          }

          return true; // Return true to indicate the assignment succeeded
        }

        throw new Error(`Property ${prop} does not exist in the state.`);
      },
    };
  }

  setBookingInitial(val = null) {
    if (val) {
      return val;
    }

    if (this.isMobile || this.isTablet) {
      return this.elementProps.NAVBAR_ELEMENT_HEIGHT + this.elementProps.TOPBAR_ELEMENT_HEIGHT + 24;
    }

    return this.elementProps.NAVBAR_ELEMENT_HEIGHT + this.elementProps.TOPBAR_ELEMENT_HEIGHT + 48;
  }

  setBookingStickyDown(val = null) {
    if (val) {
      return val;
    }

    if (this.hasDestinationMenu) {
      switch (this.currentState.DESTINATION_NAVBAR) {
        case "initial":
          return 0;
        case "sticky":
          return this.elementProps.DESTINATION_NAVBAR_ELEMENT_HEIGHT;
        default:
          return 0;
      }
    }

    return 0;
  }

  setBookingElementHeight() {
    if (this.isMobile || this.isTablet) {
      return this.hasBookingBar ? document.querySelector(".js-booking-bar-mobile-btn").getBoundingClientRect().height : 0;
    }

    return this.hasBookingBar ? document.querySelector(".js-booking-bar-animation-wrapper").getBoundingClientRect().height : 0;
  }

  setBookingStickyInit(val) {
    this.constants.BOOKING_STICKY_INIT = val;
  }

  setDestinationNavbarState(val) {
    this.proxyCurrentState.DESTINATION_NAVBAR = val;
  }

  setCheckAvailabilityBtnState(val) {
    this.proxyCurrentState.CHECK_AVAILABILITY_BTN_ELEMENT = val;
  }
}

const headerAnimationDataProvider = new AnimationDataProvider();

// eslint-disable-next-line import/prefer-default-export
export { headerAnimationDataProvider };
